<template>
  <section class="trainers">
    <!--
    <v-progress-linear v-if="loading" indeterminate color="primary"></v-progress-linear>
    <vue-easy-lightbox
      :visible="isLightboxVisible"
      :imgs="lightboxImg"
      @hide="isLightboxVisible = false"
    />
    -->
    <v-container>
      <v-row>
        <div class="heading">
          <span>Découvrez nos partenaires</span>
          <p>
            Sportopia est la premiere plateforme en Tunisie de coaching sportif
            en ligne.
          </p>
        </div>
      </v-row>

      <v-row v-if="coachs.length > 0">
        <v-col
          xs="12"
          sm="12"
          md="4"
          lg="3"
          class="responsive-pad"
          v-for="item in activeCoachs"
          :key="item._id"
        >
          <div class="profile">
            <div class="at-user">
              <div class="at-user__avatar">
                <v-img
                  position="50% 10%"
                  :alt="item.fullName"
                  @click="
                    isLightboxVisible = true;
                    lightboxImg = item.photoUrl;
                  "
                  :src="photoConvert(item.photoUrl)"
                  :lazy-src="photoConvert(item.photoUrl)"
                ></v-img>
              </div>
              <div class="at-user__name">{{ item.fullName }}</div>
              <div class="at-user__title" v-if="item.coach.specialities">
                {{ item.coach.specialities[0] }}
              </div>
              <div class="at-user__title" v-else>
                aucune spécialité spécifiée
              </div>
              <div class="at-user__price" v-if="item.coach.sessionPrice">{{item.coach.sessionPrice}}TND</div>
              <v-btn class="cnxBtn" :to="'/trainer/' + item._id"
                >Consulter</v-btn
              >
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <template>
      <div class="text-center"></div>
    </template>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import VClamp from "vue-clamp";
import GradientButton from "@/components/UI/GradientButton";
export default {
  data() {
    return {
      lightboxImg: "",
      isLightboxVisible: false,
    };
  },
  components: {
    VClamp,
    GradientButton,
  },
  created() {
    if (
      this.coachs == null ||
      this.coachs == undefined ||
      this.coachs.length == 0
    ) {
      this.getCoachs();
    }
  },
  methods: {
    ...mapActions(["getCoachs"]),
    photoConvert(url) {
      if (url === null || url === undefined) {
        return process.env.VUE_APP_API_URL_COACH_AVATAR;
      }
      if (url.startsWith("uploads")) return url;
      else return url + "?height=500";
    },
  },
  computed: {
    ...mapGetters({
      coachs: "coachs",
      loading: "loading",
    }),
    activeCoachs: function () {
      return this.coachs.filter(function (c) {
        return c.fullName && c.photoUrl;
      });
    },
  },
};
</script>

<style scoped>
.heading {
  margin: 10px auto;
  text-align: center;
}
.heading span {
  font-size: 28px;
  font-weight: 600;
  display: block;
}
.heading p {
  font-size: 16px;
  font-weight: normal;
}
.trainers {
  background: #f5f5f5;
  padding-bottom: 70px;
}
.profile {
  z-index: 0;
  position: relative;
  background: #fff;
  box-shadow: 0 0 0 1px #e2e9ed;
  padding: 35px;
  box-sizing: border-box;
  -webkit-transition: box-shadow 0.2s ease, z-index 0s 0.2s ease,
    -webkit-transform 0.2s ease;
  transition: box-shadow 0.2s ease, z-index 0s 0.2s ease,
    -webkit-transform 0.2s ease;
  transition: box-shadow 0.2s ease, transform 0.2s ease, z-index 0s 0.2s ease;
  transition: box-shadow 0.2s ease, transform 0.2s ease, z-index 0s 0.2s ease,
    -webkit-transform 0.2s ease;
}
.profile:hover {
  z-index: 1;
  box-shadow: 0 8px 50px rgba(0, 0, 0, 0.2);
  -webkit-transform: scale(1.05);
  transform: scale(1.05);
  -webkit-transition: box-shadow 0.2s ease, z-index 0s 0s ease,
    -webkit-transform 0.2s ease;
  transition: box-shadow 0.2s ease, z-index 0s 0s ease,
    -webkit-transform 0.2s ease;
  transition: box-shadow 0.2s ease, transform 0.2s ease, z-index 0s 0s ease;
  transition: box-shadow 0.2s ease, transform 0.2s ease, z-index 0s 0s ease,
    -webkit-transform 0.2s ease;
}
.at-user {
  width: 100%;
  text-align: center;
}
.at-user__avatar {
  width: 98px;
  height: 98px;
  border-radius: 100%;
  margin: 0 auto 20px;
  overflow: hidden;
}
.at-user__avatar img {
  display: block;
  width: 100%;
  max-width: 100%;
}
.at-user__name {
  color: #313435;
  font-size: 1.3rem;
  font-weight: 600;
  line-height: 2.625rem;
}
.at-user__title {
  color: #6f808a;
  font-size: 13px;
}
.at-user__price {
  color: #3cc554;
  font-size: 1.2rem;
  font-weight: 600;
}
.cnxBtn {
  background: #e91e24 !important;
  color: #fff;
  padding: 5px 30px;
  border-radius: 7px;
  /*float: right;*/
  letter-spacing: 1px;
  margin-top: 20px;
}

.ow {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  margin: 0px;
}
.grow {
  transition: all 0.2s ease-in-out;
}
.grow:hover {
  transform: scale(1.02);
}
.card-actions {
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
}
</style>
